export default __webpack_public_path__ + "help-center-icon@2x.png";